<template>
  <section class="sub-menu mb-xl">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <ul class="sub-menu__list">
            <li class="sub-menu__list-item">
              <router-link
                :to="{ name: 'StudentDashboard', params: { id: id } }"
                event=""
                class="sub-menu__list-item-link"
                active-class="active"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.2222 4H5.77778C4.79594 4 4 4.79594 4 5.77778V18.2222C4 19.2041 4.79594 20 5.77778 20H18.2222C19.2041 20 20 19.2041 20 18.2222V5.77778C20 4.79594 19.2041 4 18.2222 4Z"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4 9H20"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 20V9"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </router-link>
            </li>
            <li
              v-for="(item, index) in studentMenu"
              :key="index"
              class="sub-menu__list-item"
            >
              <router-link
                :to="{ name: item.link, params: { id: id } }"
                class="sub-menu__list-item-link"
                active-class="active"
              >
                {{ item.title }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TheStudentMenu',
  props: ['id'],
  data() {
    return {
      studentMenu: [
        {
          link: 'StudentEdit',
          title: 'פרטים אישיים'
        },
        {
          link: 'StudentSchool',
          title: 'בית הספר'
        },
        {
          link: 'StudentCenter',
          title: 'פנימיה'
        },
        {
          link: 'StudentReproachesTab',
          title: 'מערכת שעות'
        },
        {
          link: 'StudentBehavior',
          title: 'תיעוד'
        }
      ]
    };
  }
};
</script>
